import { render, staticRenderFns } from "./appHelp.vue?vue&type=template&id=13e38aae"
import script from "./appHelp.vue?vue&type=script&lang=js"
export * from "./appHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports